import { InputText } from 'primereact/inputtext';

import styles from './UsersAccessRightsFilters.module.scss';
import './Overrides.scss';
import { IFiltersData } from '../models/filtersData';
import { Control, Controller } from 'react-hook-form';
import { MultiSelect } from 'primereact/multiselect';
import { IFiltersOptions } from '../models/filtersOptions';
import { useCookies } from 'react-cookie';
import { UserAccessRightsFiltersCookiesData } from '../data/cookiesData';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import AddAccessRights from '../../add/AddAccessRights';

export interface IUsersAccessRightsFiltersProps {
	control: Control<IFiltersData>;
	filtersOptions: IFiltersOptions;
	clearFilters: () => void;
	refetch: () => void;
}

export const UsersAccessRightsFilters = ({
	control,
	filtersOptions,
	clearFilters,
	refetch
}: IUsersAccessRightsFiltersProps): JSX.Element => {
	const [cookies, setCookie] = useCookies(UserAccessRightsFiltersCookiesData);

	const { divisions, countries, brands } = filtersOptions;

	return (
		<div className={styles.container}>
			<Controller
				name={'firstName'}
				control={control}
				render={({ field, fieldState }) => (
					<InputText
						id={field.name}
						{...field}
						className={styles.filter}
						onChange={(e) => field.onChange(e.target.value)}
						placeholder='First name'
					/>
				)}
			/>

			<Controller
				name={'lastName'}
				control={control}
				render={({ field, fieldState }) => (
					<InputText
						id={field.name}
						{...field}
						className={styles.filter}
						onChange={(e) => field.onChange(e.target.value)}
						placeholder='Last name'
					/>
				)}
			/>

			<Controller
				name={'userName'}
				control={control}
				render={({ field, fieldState }) => (
					<InputText
						id={field.name}
						{...field}
						className={styles.filter}
						onChange={(e) => field.onChange(e.target.value)}
						placeholder='Username'
					/>
				)}
			/>

			<Controller
				name={'divisionId'}
				control={control}
				render={({ field, fieldState }) => (
					<Dropdown
						id={field.name}
						filter
						{...field}
						className={styles.filter}
						placeholder='Division'
						options={divisions}
						onChange={(e) => {
							field.onChange(e);
							setCookie('usersAccessRightsDivision', e.value);
						}}
					/>
				)}
			/>

			<Controller
				name={'countryIds'}
				control={control}
				render={({ field, fieldState }) => (
					<MultiSelect
						id={field.name}
						filter
						{...field}
						className={styles.filter}
						placeholder='Countries'
						options={countries}
						onChange={(e) => {
							field.onChange(e);
							setCookie('usersAccessRightsCountries', e.value);
						}}
					/>
				)}
			/>

			<Controller
				name={'brandIds'}
				control={control}
				render={({ field, fieldState }) => (
					<MultiSelect
						id={field.name}
						filter
						{...field}
						className={styles.filter}
						placeholder='Brands'
						options={brands}
						onChange={(e) => {
							field.onChange(e);
							setCookie('usersAccessRightsBrands', e.value);
						}}
					/>
				)}
			/>

			<Button className={styles.filterClearBtn} onClick={clearFilters}>
				<img src='/assets/icon-trash.svg' alt='trash icon' />
				Clear all filters
			</Button>

			<AddAccessRights refetch={refetch} />
		</div>
	);
};
